import React from 'react';
import { lunazoneConfig } from '../demoConfigs';
import ReusableDemoPage from "../ReusableDemoPage";
const LunazoneDemo = () => {
  return <ReusableDemoPage config={lunazoneConfig} />;
};

export default LunazoneDemo;